<!-- 月度计划管理 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button icon="el-icon-add" type="primary" size="small" @click="handleAdd">新增</el-button>
        <!-- <el-button type="danger" icon="el-icon-delete" plain :disabled="selectionList.length == 0" @click="handleDelete">批量删除</el-button> -->
      </template>
      <template slot-scope="{row,index}" slot="menu">
        <el-button
         style="margin-left:20px;"
        icon="el-icon-delete"
        size="small"
        type="text"
        @click="showMore(row,index)">修改</el-button>
        <el-button
        v-if="row.planStatus == 3"
        style="margin-left:20px;"
        icon="el-icon-delete"
        size="small"
        type="text"
        @click="audit(row,index)">审核</el-button>
        <el-popconfirm v-if="row.planStatus == 1"  title="确定修订此条数据吗" @confirm="revise(row,index)">
        <el-button  size="small"
          style="margin-left:20px;"
        type="text" slot="reference">修订</el-button>
      </el-popconfirm>
      </template>

    </avue-crud>

    <!-- 子表内容：与「应急预案-新增界面」原型一致，多 Tab 整单提交 insert-detail / update-detail -->
    <dialog-reset slotShow height="78vh" top="4vh" width="88%" custom-class="y-plan-dialog" :title="planFormTitle" :visible.sync="formVisible">
      <WantMore ref="formComponen" :key="planFormKey" :is-edit="isEdit" :info-more="infoMore" />
      <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="submit">提 交</el-button>
    </span>
    </dialog-reset>
    <dialog-reset slotShow height="45vh" top="15vh" width="60%" title="审核" :visible.sync="auditFormVisible">
      <WantAudit ref="auditForm" v-if="auditFormVisible"></WantAudit>
      <span slot="dialog_footer">
      <el-button type="primary"
                 icon="el-icon-circle-plus-outline"
                 @click="auditSubmit">提 交</el-button>
                </span>
    </dialog-reset>

  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, selectDetail,audit,revise } from "./api";
import { getSearchTimeConfig,rulesInput } from "@/basic-common/util/common";
import matrixStatistics from '@/components/matrix/matrix-statistics'
import SelectContract from "./components/select-contract.vue";

import WantMore from './components/want-more.vue'
import WantAudit from './components/want-audit.vue'
export default {
  components: { matrixStatistics, SelectContract, WantMore,WantAudit,},
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      isEdit:true,
      auditId:'',
      infoMore: {},
      form: {},
      auditFormVisible:false,
      formVisible:false,
      planFormKey: 0,

      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        submitBtn: false,
      emptyBtn: false,
      viewBtn:false,
      addBtn:false,
      editBtn:false,
      delBtn:true,
        column: [
          {
            label: '预案编号',
            prop: 'planCode',
            overHidden: true, // 表格超出隐藏
            minWidth: 150,
            maxlength: 30,
            rules: rulesInput(1),
          },
          {
            label: '预案名称',
            prop: 'planName',
            overHidden: true, // 表格超出隐藏
            minWidth: 150,
            maxlength: 30,
            search: true,
            rules: rulesInput(1),
          },
          {
            label: '预案类型',
            prop: 'planType',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            hide: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=yj-pla-type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: rulesInput(2),
          },
          // {
          //   label: '预案标签',
          //   prop: 'planType',
          //   overHidden: true, // 表格超出隐藏
          //   width: 150,
          //   type: 'input',
          //   maxlength: 50,
          //   placeholder: '请输入预案标签',
          // },
          {
            label: '预案状态',
            prop: 'planStatus',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: "select",
            remote: true,
            hide: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=yj-pla-status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: rulesInput(2),
          },
          {
            label: '修订时间',
            prop: 'revisionTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入时间',
            prop: 'issueTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '录入人员',
            prop: 'createUser',
            overHidden: true, // 表格超出隐藏
            width: 120,
            addDisplay: false,
            editDisplay: false,
          },

          {
            ...getSearchTimeConfig('', { type: 'datetimerange' }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
      defaultParams: {  }
    }
  },
  computed: {
    planFormTitle () {
      return this.isEdit ? '编辑应急预案' : '新增应急预案'
    }
  },
  methods: {
    audit(row){
      this.auditFormVisible = true
      this.auditId = row.id
    },
    revise(row){
      revise({
          id:row.id
        }).then(({data}) =>{
          if(data.code === 200){
          this.$message.success(data.msg)
          this.onLoad(this.page)
        }
        })
    },
    auditSubmit(){
      if(this.$refs.auditForm){
        const data = this.$refs.auditForm.echoData()
        audit({
          ...data,
          id:this.auditId
        }).then(({data}) =>{
          if(data.code === 200){
          this.$message.success(data.msg)
          this.auditFormVisible = false
          this.onLoad(this.page)
        }
        })
      }
    },
    submit(){
      if(this.$refs.formComponen){
        console.log(`当前是编辑`,this.isEdit)
        if(this.isEdit){
          const mixData = this.$refs.formComponen.echoData()
        update({
        ...mixData,
      }).then(({data})=>{
        if(data.code === 200){
          this.$message.success(data.msg)
          this.formVisible = false
          this.onLoad(this.page)
        }
      })
      }else{
        const mixData = this.$refs.formComponen.echoData()
        add({
        ...mixData,
      }).then(({data})=>{
        if(data.code === 200){
          this.$message.success(data.msg)
          this.formVisible = false
          this.onLoad(this.page)
        }
      })
      }

      }


    },
    handleAdd(){
      this.infoMore = {}
      this.isEdit = false
      this.planFormKey += 1
      this.formVisible = true
    },
    showMore(row){
      this.isEdit = true
      selectDetail(row.id).then(({data})=>{
        this.infoMore = data.data || {}
        this.planFormKey += 1
        this.formVisible = true
      })

    },
    replace (row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
</style>
<style lang="scss">
.y-plan-dialog {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.18);

  .el-dialog__header {
    padding: 18px 28px;
    border-bottom: 1px solid #e8eef7;
    background: #fff;
  }

  .el-dialog__title,
  .centers span {
    font-size: 18px;
    font-weight: 600;
    color: #1f2d3d;
  }

  .el-dialog__body {
    padding: 16px 18px 0;
    background: #f4f7fb;
  }

  .el-dialog__footer {
    padding: 12px 24px;
    border-top: 1px solid #e8eef7;
    background: #fff;
    text-align: right;
  }

  .el-dialog__footer .el-button {
    min-width: 96px;
    border-radius: 4px;
  }
}
</style>
